import { format, parse } from 'date-fns';
import compact from 'lodash/compact';
import uniqBy from 'lodash/uniqBy';
import { DATE_FORMAT } from '@yme/molecules/date-picker/constants';
export const getOptions = (data, key) => {
    const options = compact(uniqBy(data.flatMap(key), 'label')).filter((option) => option.label);
    return options.map((option) => ({
        label: option.label,
        value: option.value || option.label,
        checked: false,
    }));
};
export const filterAndMapUnits = (units, filterOptions, existingOptions, selectedUnits) => {
    return filterOptions.options
        .filter((unitOption) => units.includes(unitOption.label))
        .map((unitOption) => {
        return {
            ...unitOption,
            checked: selectedUnits.includes(unitOption.value),
        };
    });
};
export const parseDate = (dateString, format) => {
    return parse(dateString, format, new Date());
};
export const formatDate = (date) => {
    return date ? format(date, DATE_FORMAT['dd-MM-yyyy']) : '';
};
export const updateFilterConfig = (initialConfig, appliedFilters) => {
    return initialConfig.map((filter) => {
        if (filter.options && appliedFilters.filters[filter.id]) {
            const selectedOptions = appliedFilters.filters[filter.id];
            return {
                ...filter,
                options: filter.options.map((option) => ({
                    ...option,
                    checked: selectedOptions.includes(option.label),
                })),
            };
        }
        return filter;
    });
};
export const countAllCheckedFilters = (data) => data.filter(({ options }) => options.some(({ checked }) => checked)).length;
export const countCheckedOptions = (options) => options.filter(({ checked }) => checked).length;
export const mapFilterKeys = {
    partnerName: (item) => item?.partnerReference?.partnerName,
};
export const sortFilterOptionsAlphabetically = (options) => {
    return options.sort((a, b) => {
        const labelA = a.label.trim().toLowerCase();
        const labelB = b.label.trim().toLowerCase();
        return labelA.localeCompare(labelB);
    });
};
